<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/export-forum">专家讲坛</router-link></li>
                <li class="currentNode"><a>专家讲坛详情</a></li>
            </ul>
            <div class="page-main">
                    <div class="page-main-tp">
                        <div>
                            <div class="dt">
                                <span class="day">{{ publishTime  | traverseDate('day')}}</span>
                                <span class="bias">/</span>
                                <span class="month"><i>{{ publishTime  | traverseDate('month')}}月</i><i></i>{{ publishTime  | traverseDate('year')}}</span>
                            </div>
                            <div class="dd">协会动态</div>
                        </div>
                        <div class="article-title">
                            <h3>{{ title }}</h3>
                            <p class="subtitle">{{ subTitle }}</p>
                        </div>
                    </div>
                    <div class="page-main-btm content-detail"  v-html="content"></div>
                        <!-- <p>本次研讨会邀请到了农业农村部、国家信息中心、商务部、平谷农业中关村管委会、山东德州、广西南宁等各级、各地方政府相关领导、国内外行业专家、优秀企业代表、会员单位共计130余人现场出席会议。同时，线上直播吸引观众高达5万余人，各界人士通过本次会议进一步了解到数字乡村的国际国内最新技术与发展。</p>
                        <p>研讨会上，农业农村部市场预警专家委员会秘书长、农业农村部农业信息服务技术重点实验室主任许世卫在致辞中指出，数字乡村建设应该说是全方位的数字乡村发展的整体体系建设，是一种针对更好的解决农业能力、技术应对能力的工作，数字乡村建设适应我们当前的需要。</p> -->
                    
                </div>
            
        </div>
    </div>
</template>

<script>
import {
    getPlolicyDetail
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            detailId: '',
            publishTime: '',
            title: '',
            subTitle: '',
            content: '',
            parentNav: '',
            parentLink: '',
            type: '',
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.type = this.$route.query.type;
        // this.traverseTitle();
        this.getPlolicyDetail(this.detailId);
    },
    methods: {
        traverseTitle() {
            if (this.type === '1'){
                this.parentNav = "动态要闻";
                this.parentLink = '/layout/association-trends?id=1';
            } else if (this.type === '2'){
                this.parentNav = "协会动态";
                this.parentLink = '/layout/association-trends?id=2';
            } else if (this.type === '3') {
                this.parentNav = "协会工作";
                this.parentLink = '/layout/association-trends?id=3';
            }
        },
        getPlolicyDetail(id) {
            let params = {
                id: id
            };
            getPlolicyDetail(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    this.subTitle = res.Data.SubTitle;
                    this.content = res.Data.Content;
                } else {
                    this.$message.error("专家讲坛详情求失败");
                }
            })
        },
    }
}
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
</style>